<ng-container *ngIf="contentlet$ | async as contentlet">
  <custom-dot-cms-edit-contentlet-wrapper [contentlet]="contentlet" class="d-block">
    <custom-dot-cms-web-page-content
      [identifier]="contentlet?.identifier"
      [setAttribute]="false"
    ></custom-dot-cms-web-page-content>
  </custom-dot-cms-edit-contentlet-wrapper>
</ng-container>
